import React from "react";

import { nameValidationPattern } from "@gp/common";

import { FormInputField } from "@components-shared/desktop/inputs";

export default function OnboardingRegistrationBirthName(props: {
	labelClassName?: string;
}) {
	const { labelClassName } = props;

	return (
		<FormInputField
			id="birthName"
			name="birthName"
			className="form__field u-mar--bottom--reset"
			labelClassName={labelClassName}
			label="registration:BIRTH_NAME_LABEL"
			inputClassName="input input--sml input"
			placeholder="registration:BIRTH_NAME_PLACEHOLDER"
			pattern={{
				value: nameValidationPattern,
				message: "registration:INVALID_BIRTH_NAME",
			}}
		/>
	);
}
